import { getServerTime, checkTimeBetween } from '@/utils/date-helper';
import { i18n } from '@/i18n';

// 99公益日日期
export const isTencentCharity = () => {
  const targetTime = getServerTime();
  const startDate: Date = new Date('2023/09/01 00:00:00');
  const endDate: Date = new Date('2023/09/10 23:59:59');
  if (checkTimeBetween({targetTime, startDate, endDate})) {
    return true;
  }
  return false;
};

export function getStampTitleList() {
  const arr = [
    {
      text: i18n('每日完成首筆消費可獲得小紅花，1朵小紅花=HK$1'),
      biTag: '2',
    },
    {
      text: i18n('騰訊基金會將會捐出小紅花等額善款'),
      biTag: '3',
    },
  ];
  const nineTitlte = {
    text: i18n('9月1日-9月10日期間消費可得雙倍小紅花'),
    biTag: '1',
  };
  return isTencentCharity() ? [nineTitlte, ...arr]: arr;
}
